module.exports = __webpack_public_path__ + "img/facebook.e17ce5d.svg";